import { object, string } from 'yup';

import { EMAIL } from './consts';

export const validationSchema = object().shape({
  [EMAIL]: string().trim().customEmail('E-Mail-Adresse ist ungültig.').required('E-Mail-Adresse fehlt.'),
});
